export default __webpack_public_path__ + "static/media/DoneIcon.f5988a68.svg";